import moment from "moment";
import React from "react";
import { formatWrittenDayMonth } from "../utilities";
import { Reminder } from "./models";

interface Props {
  value: Reminder
  dueMoment: moment.Moment
  isLast: boolean
  documentLifeCycle: server.dto.DocumentLifeCycles

  onClearLastReminder: () => void
  onReminderEdit: (reminder: Reminder) => void
}

moment.relativeTimeRounding(Math.ceil);

const InvoiceReminderRowCard = (props: Props) => {
  const { value, isLast, dueMoment } = props;

  const isPending = props.documentLifeCycle === "draft" || props.documentLifeCycle === "review";

  const cardColor = value.isSent ? "gray" : "blue";

  const cardStyle: React.CSSProperties = {
    borderLeft: `solid 6px var(--${cardColor})`,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
  };

  const reminderMoment = moment.utc(dueMoment).add(value.days, "days");

  return <>
    <div className="flex-column padding gap-small" style={cardStyle}>
      <div>
        <h4>
          {RESX.Reminder.xReminder}&nbsp;{value.reminderNr}
        </h4>
      </div>

      <div>
        {value.isSent && <span>{RESX.Message.EmailSent}</span>}
      </div>
    </div>

    {isPending && <div className="padding flex-column gap-small">
      <div>
        <a onClick={() => { props.onReminderEdit(props.value); }}>{value.days} {RESX.DateTime.days} {RESX.DateTime.afterDueDate}</a>
      </div>
      <div>
        {formatWrittenDayMonth(reminderMoment)}
      </div>
    </div>}

    {!isPending && <div className="padding">

      {!value.isSent && <div>
        <a onClick={() => { props.onReminderEdit(props.value); }}>{formatWrittenDayMonth(reminderMoment)}</a>
      </div>}

      {value.isSent && <div>
        {formatWrittenDayMonth(reminderMoment)}
      </div>}

      <div className="s1_small">
        {reminderMoment.fromNow()}
      </div>
    </div>}

    <div className="padding">
      {!value.isSent && isLast && <a onClick={props.onClearLastReminder} className="icon-x red"></a>}
    </div>
  </>;
};

export default InvoiceReminderRowCard;